module.exports = __webpack_public_path__ + "static/media/basilica_Krakovia.49fef320.png";